import React, { useState } from 'react';
import { XIcon, ArrowRightIcon } from 'lucide-react';
import { Container } from './ui/Container';
export function AnnouncementBar() {
  const [isVisible, setIsVisible] = useState(true);
  if (!isVisible) return null;
  return <div className="bg-iris-green text-iris-black font-mono text-xs sm:text-sm py-2 relative z-50" data-id="element-18">
      <Container className="flex items-center justify-between" data-id="element-19">
        <div className="flex items-center gap-2" data-id="element-20">
          <span className="font-bold animate-pulse" data-id="element-21">●</span>
          <span className="opacity-80" data-id="element-22">{'// ACTIVE:'}</span>
          <span className="font-medium" data-id="element-23">
            Florida Immigration Enforcement Grant — Eligible Agencies
          </span>
          <a href="#grants" className="inline-flex items-center gap-1 font-bold hover:underline ml-2" data-id="element-24">
            Learn More <ArrowRightIcon className="w-3 h-3" data-id="element-25" />
          </a>
        </div>
        <button onClick={() => setIsVisible(false)} className="p-1 hover:bg-black/10 rounded transition-colors" aria-label="Dismiss announcement" data-id="element-26">
          <XIcon className="w-4 h-4" data-id="element-27" />
        </button>
      </Container>
    </div>;
}